module.exports = __webpack_public_path__ + "static/media/jica_1.e6464447.png";